<template lang="pug">
  .tile.sender-dashboard.is-vertical-center
    .tile.is-12
      .tile.is-2.is-vertical.create-btn-wrap(v-if="!offer.id")
        router-link.main-btn.col-white.bg-red(:to="{name: 'CreateCV', params:{lang: getLanguage}}")
          span(@click="showNav = false") {{ gettext('Create new CV') }}
      .tile.is-12.offer(v-if="offer.id")
        router-link(:to="{name: 'Vacancy', params: {lang: getLanguage, id: offer.id, previous: $route}}")
          span.offer-text {{ gettext('Send cv`s to') + ': ' }}
            b {{ offer.name }}
    .tile.is-12.to-offer-controls(v-if="offer.id")
      .tile.is-1.is-vertical.create-btn-wrap()
        a.main-btn.col-white.bg-red(@click="$router.back()")
          span(@click="showNav = false") {{ gettext('Back') }}
      .tile.is-1.is-vertical.create-btn-wrap()
        button.main-btn.col-white.bg-red(@click="sendCvs()" :disabled="!selectedCvs.length")
          span(@click="showNav = false") {{ gettext('Send') }}
    .tile.is-12.sender-dashboard-right
      .tile.is-2.is-vertical-center.filters-block
        .is-12.filters(:class="{'open': openFilters}")
          p.title {{ gettext('Filters by statuses') + ':' }}
          .filter(
          v-for="filter in statuses"
          :class="{'active': currentFilter === filter.id}"
          @click="setFilter(filter.id)"
          ) {{filter.name}}
      .tile.is-10.cvs
        .tile.is-12.is-vertical-center
          .tile.is-12.actions(:class="{'disable': !selectedCvs.length}")
            div(v-if="!offer.id" @click="publish(true)") {{ gettext('Publish') }}
            div(v-if="!offer.id" @click="publish(false)") {{ gettext('Unpublish') }}
            div(v-if="!offer.id" @click="selectedCvs.length ? ShowChangeStatusModal = true : ShowChangeStatusModal = false") {{ gettext('Change status') }}
            div(v-if="!offer.id" @click="selectedCvs.length ? showDeleteModal = true : showDeleteModal = false") {{ gettext('Delete') }}
          .tile.is-12.table-wrap
            .no-cvs(v-if="!(cvs.items || {}).length")
              .content.is-fluid
                .notification
                  .has-text-centered.is-size-4 {{ gettext('No CV`s') }}
            .table-wrap-inner(v-else)
              table
                tr.cv
                  td(@click="selectAll")
                    input(type="checkbox" v-model="selectedAll")
                  td #
                  td ID
                  td {{ gettext('Status on site') }}
                  td {{ gettext('Photo') }}
                  td {{ gettext('Status') }}
                  td {{ gettext('First name') }}
                  td {{ gettext('Last name') }}
                  td {{ gettext('Age') }}
                  td {{ gettext('Profession') }}
                  td {{ gettext('Sector') }}
                  td {{ gettext('Branch') }}
                  td {{ gettext('Type of employment') }}
                  td {{ gettext('Experience') }}
                  td {{ gettext('Languages') }}
                  td {{ gettext('Drivers license') }}
                router-link.cv(
                v-for="(cv, index) in cvs.items"
                :key="cv.id"
                :to="{name: 'EditCV', params: {lang: getLanguage, id: cv.id}}"
                :class="{'is-danger': responseItems.find(x => x.cv_id === cv.id && !x.sent), 'is-success': responseItems.find(x => x.cv_id === cv.id && x.sent)}"
                )
                  td(@click.prevent="selectCv(cv)")
                    input(type="checkbox" v-model="cv.checked")
                  td {{ getListNumber(index) }}
                  td {{ cv.id }}
                  td.status
                    span.on(v-if="cv.is_active") {{ gettext('On') }}
                    span.off(v-else) {{ gettext('Off') }}
                  td.photo
                    .avatar(v-if="cv.image_urls" :style="{'background-image': `url(${cv.image_urls.min})`}")
                    div(v-else).mdi.mdi-account.mdi-48px
                  td {{ cv.status }}
                  td {{ cv.first_name }}
                  td {{ cv.last_name }}
                  td {{ cv.age }}
                  td {{ (cv.profession || {}).name || '-' }}
                  td {{ (cv.profession_company_sector || {}).name || '-' }}
                  td {{ (cv.profession_company_type || {}).name || '-' }}
                  td(v-if="cv.is_trainee") {{ gettext('Trainee') }}
                  td(v-else) {{ cv.is_skilled ? gettext('Skilled worker') : gettext('Unskilled worker') }}
                  td {{ cv.experience.join(', ') || '-' }}
                  td {{ cv.languages.join(', ') }}
                  td {{ cv.driving_licences.map(x => x.name).join(', ') || '-' }}
          vue-paginate(
          v-if="cvs.total_items"
          :page-count="cvs.total_pages"
          :page-range="10"
          :initial-page="currentPage-1"
          :clickHandler="toPage"
          )
    v-modal(:show.sync="showDeleteModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Are you sure want to delete it') }}?
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(@click="deleteCvs") {{ gettext('Yes') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showDeleteModal = false") {{ gettext('No') }}
    v-modal(:show.sync="showSentStatusModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Do you want to update status for sent CVs') }}?
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(@click="updateSentCvsStatus") {{ gettext('Yes') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showSentStatusModal = false") {{ gettext('No') }}
    v-modal.custom-modal(:show.sync="ShowChangeStatusModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Select new status') }}
        .select-stauts
          ajax-dropdown.wide(
          v-model="selectedStatus"
          :labelText="gettext('Choose status')"
          :returnItem ="'id'"
          :itemName ="'name'"
          :action="{method: 'getSenderStatuses', params: {lang: getLanguage}}"
          )
          .main-btn.col-white.bg-red(:disabled="!selectedStatus || !selectedCvs.length" @click="changeStatus")
            span {{ gettext('Save') }}
    v-modal(:show.sync="offerResponseModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{gettext('Sending status')}}
        .notification.is-success(v-if="offerResponseMessage.success")
          .is-size-5 {{gettext('You have successfully sent these CV`s')}}:
          strong {{offerResponseMessage.success}}
        .notification.is-danger(v-if="offerResponseMessage.error")
          .is-size-5 {{gettext('Warning! You have already sent these CV`s')}}:
          strong {{offerResponseMessage.error}}
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(@click="$router.push({name: 'Vacancy', params: {lang: getLanguage, id: offer.id, previous: $route}})") {{ gettext('Back to offer') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="offerResponseModal = false") {{ gettext('Close') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VuePaginate from '@/components/paginate'
import VModal from '@/components/modal'
import AjaxDropdown from '@/components/ajax-dropdown'

const toastr = require('toastr')

export default {
  name: 'SenderDashboard',
  data () {
    return {
      openFilters: true,
      currentPage: parseInt(this.$route.query.page) || 1,
      currentFilter: null,
      cvs: [],
      pageSize: 10,
      offer: {},
      selectedCvs: [],
      showDeleteModal: false,
      selectedAll: false,
      statuses: {},
      responseItems: [],
      selectedStatus: null,
      sentStatusId: null,
      showSentStatusModal: false,
      ShowChangeStatusModal: false,
      offerResponseModal: false,
      offerResponseMessage: {
        success: '',
        error: ''
      },
      lastSentCvs: []
    }
  },
  components: {
    VuePaginate,
    VModal,
    AjaxDropdown
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveSenderCvs',
      'getVacancy',
      'deleteSenderCvs',
      'updateSenderCvsActivity',
      'getSenderStatuses',
      'sendCvToJoboffer',
      'setSenderCvsStatus'
    ]),
    updateSentCvsStatus () {
      this.showSentStatusModal = false
      this.setSenderCvsStatus({cvs: this.lastSentCvs.map(x => x.cv_id), status: this.sentStatusId}).then(res => {
        this.getCvs()
      })
    },
    changeStatus () {
      if (!this.selectedStatus || !this.selectedCvs.length) return
      this.ShowChangeStatusModal = false
      this.setSenderCvsStatus({cvs: this.selectedCvs, status: this.selectedStatus}).then(res => {
        this.getCvs()
      })
    },
    setSentStatusId () {
      this.sentStatusId = this.statuses.find(x => x.is_sent).id
    },
    selectAll () {
      this.selectedAll = !this.selectedAll
      let status = this.selectedAll
      this.cvs.items.map(x => {
        x.checked = status
      })
      this.$forceUpdate()
      this.updateSelectedCvs()
    },
    sendCvs () {
      if (!this.selectedCvs.length) return
      this.sendCvToJoboffer({lang: this.getLanguage, cv: this.selectedCvs, offer: parseInt(this.$route.query.offer)}).then(res => {
        this.selectedCvs = []
        this.selectedAll = false
        this.cvs.items.map(x => {
          x.checked = false
        })
        this.responseItems = res.items
        let alreadySent = res.items.filter(x => x.is_already_sent)
        if (alreadySent.length) {
          let result = alreadySent.map((item) => item.cv_id)
          this.offerResponseMessage.error = result.join(', ')
        }
        this.lastSentCvs = res.items.filter(x => x.sent)
        if (this.lastSentCvs.length) {
          let result = this.lastSentCvs.map((item) => item.cv_id)
          this.offerResponseMessage.success = result.join(', ')
          this.showSentStatusModal = false
        }
        if (this.lastSentCvs.length || alreadySent.length) {
          this.offerResponseModal = true
        }
      })
    },
    deleteCvs () {
      this.showDeleteModal = false
      this.deleteSenderCvs({data: this.selectedCvs}).then(res => {
        this.getCvs()
      })
    },
    publish (status) {
      if (!this.selectedCvs.length) return
      this.updateSenderCvsActivity({data: this.selectedCvs, status: status}).then(res => {
        this.getCvs()
      })
    },
    selectCv (cv) {
      cv.checked = !cv.checked
      this.selectedAll = true
      this.$forceUpdate()
      this.updateSelectedCvs()
      if (!this.selectedCvs.length) {
        this.selectedAll = false
      }
    },
    updateSelectedCvs () {
      let arr = []
      this.cvs.items.map(x => {
        if (x.checked) {
          arr.push(x.id)
        }
      })
      this.selectedCvs = arr
    },
    toPage (page) {
      this.currentPage = +page
      this.getCvs()
    },
    getCvs () {
      this.receiveSenderCvs({pageNum: this.currentPage, pageSize: this.pageSize, status: this.currentFilter}).then(res => {
        this.cvs = res
        this.selectedCvs = []
        this.selectedAll = false
      })
    },
    setFilter (key) {
      if (key === this.currentFilter) {
        this.currentFilter = null
      } else {
        this.currentFilter = key
      }
      this.openFilters = !this.openFilters
      this.getCvs()
    },
    getListNumber (index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    '$route' (to, from) {
      if (!to.query.offer) {
        this.offer = {}
      }
    },
    offerResponseModal (val) {
      if (!val) {
        this.offerResponseMessage.success = ''
        this.offerResponseMessage.error = ''
        setTimeout(() => {
          this.responseItems = []
        }, 5000)
      }
    }
  },
  created () {
    this.getSenderStatuses({lang: this.getLanguage}).then(res => {
      this.statuses = res
      this.setSentStatusId()
    })
    this.getCvs()
    if (this.$route.query.offer) {
      this.getVacancy({lang: this.getLanguage, id: parseInt(this.$route.query.offer)}).then(res => {
        this.offer = res
      }).catch(err => {
        if ((err.data.error || {}).message) {
          toastr.warning(err.data.error.message, 'Warning')
        }
        this.$router.push({name: 'FindJob', params: {lang: this.getLanguage}})
      })
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/dashboard/sender/index.vue